// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
export const SYMPTOMS = [
  { name: "fever", label: "Fever" },
  { name: "cough", label: "Cough" },
  { name: "tired", label: "Feeling tired" },
  { name: "chills", label: "Chills or sweats" },
  { name: "sorethroat", label: "Sore Throat" },
  { name: "headache", label: "Headache" },
  { name: "aches", label: "Muscle or body aches" },
  { name: "nose", label: "Runny or stuffy nose" },
  { name: "breath", label: "Shortness of breath" },
  { name: "vomit", label: "Vomiting" },
];

export const FIELDS_SUFFIX = {
  START: "_start",
  _48H: "_48H",
  _SEVERITY: "_severity",
};
